<template>
  <div>
    <v-data-table
      :items-per-page="itemsPerPage"
      :no-data-text="$t('table.noResults')"
      :loading="isLoading"
      :headers="awaitingApprovalHeaders"
      :items="adminInvoices"
      hide-default-footer
      calculate-widths
      disable-sort
      show-expand
    >
      <template v-slot:item.created_at="{ item }">
        {{ date(item.created_at) }}
      </template>
      <template v-slot:item.invoice_file_analysis="{ item }">
        <InvoiceAutomaticValidationIcons :invoice="item" />
      </template>
      <template v-slot:item.sender="{ item }">
        {{ sender(item) }}
      </template>
      <template v-slot:item.receiver="{ item }">
        {{ receiver(item) }}
      </template>
      <template v-slot:item.total="{ item }">
        {{ formatMoney(item.total) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <AdminInvoiceTableMenu @retryTransfer="retryTransfer" :invoice="item" />
      </template>
      <template v-slot:[`expanded-item`]="{ headers, item }">
        <td :colspan="headers.length" class="content pl-13 pb-10">
          <v-card class="rounded-b-lg" outlined>
            <PaymentList :payments="item.payment_list" />
          </v-card>
        </td>
      </template>
    </v-data-table>

    <v-divider />

    <h-pagination
      :fetch="fetchAdminInvoices"
      :requireOrderByFilter="false"
      :noBorders="true"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { catalogDate, catalogMonetary } from '@/util/catalog'
import { invoiceHeaders, awaitingApprovalHeaders } from '../adminInvoiceHeaders'

import PaymentList from './fragments/PaymentList'
import AdminInvoiceTableMenu from './fragments/AdminInvoiceTableMenu'
import InvoiceAutomaticValidationIcons from './fragments/InvoiceAutomaticValidationIcons'

export default {
  name: 'AdminAwaitingApprovalInvoices',

  components: {
    PaymentList,
    AdminInvoiceTableMenu,
    InvoiceAutomaticValidationIcons,
  },

  computed: {
    ...mapGetters(['adminInvoices', 'itemsPerPage', 'isLoading']),
  },

  methods: {
    ...mapActions(['fetchAdminInvoices']),

    date(date) {
      return date ? catalogDate(date) : '---'
    },

    description(description) {
      return description ?? '---'
    },

    sender(item) {
      return item.sender ? this.$t(`hausefulInvoices.${item.sender}`) : '---'
    },

    receiver(item) {
      return item.receiver ? this.$t(`hausefulInvoices.${item.receiver}`) : '---'
    },

    retryTransfer(invoice) {
      this.$emit('retryTransfer', invoice)
    },
  },

  data() {
    return {
      invoiceHeaders,
      awaitingApprovalHeaders,
      formatMoney: catalogMonetary,
    }
  },
}
</script>
